import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularMaterialModule } from './angular-material.module';
// import { RegisterComponent } from './components/register/register.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NpnSliderModule } from 'npn-slider';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { WebReqInterceptor } from './services/web-req.interceptor';
// import { HomeComponent } from './components/home/home.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { Data } from './helper/datastore';
import { DndDirective } from './directives/dnd.directive';
import { ConfirmEqualValidatorDirective } from './validators/confirm.fields.validator.directive';
import { CookieService } from 'ngx-cookie-service';
import { EmailService } from './helper/email-trigger.service';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { SharedModuleModule } from './shared-module.module';
import { CommonCounterComponent } from './common-counter/common-counter.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { environment } from '../environments/environment';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { MessagingService } from './services/messaging.service';
import { SearchFilterPipe } from './search-filter.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
// import { MatDatepickerModule } from '@angular/material';
import { OffersModule } from './modules/offers/offers.module';
import { OffersComponent } from './modules/offers/offers.component';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
// import { MatCardModule } from '@angular/material';
import { ManagePhotoComponent } from './components/manage-photo/manage-photo.component';
import { AuthGuard } from './guards/auth.guard';
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { LoaderComponent } from './components/builders/loader/loader.component';
import { PopupComponent } from './components/builders/popup/popup.component';
import { ImageSliderComponent } from './components/image-slider/image-slider.component';
import { EditViewSlideShowComponent } from './components/common/edit-view-slide-show/edit-view-slide-show.component';
import { ProfileTypeDialogComponent } from './modules/education/profile-type-dialog/profile-type-dialog.component';
import { CustomersDialogComponent } from './modules/dashboard/customers-dialog/customers-dialog.component';
import { CustomerLeftUpdateDialogComponent } from './modules/dashboard/customer-left-update-dialog/customer-left-update-dialog.component';
import { BrokerCreateDialogComponent } from './modules/admin-forms/broker-create-dialog/broker-create-dialog.component';
import { ReasonDialogComponent } from './modules/view-profile/reason-dialog/reason-dialog.component';
import { OldSlideShowComponent } from './modules/matchfollowup/old-slide-show/old-slide-show.component';
import { UtilitiesService } from './services/utilities.service';
import { FormatHistoryComponent } from './modules/communicationlog/format-history/format-history.component';
import { CreateemployeeComponent } from './modules/admin-forms/createemployee/createemployee.component';
import { TicketHistoryComponent } from './modules/service-slide-show/ticket-history/ticket-history.component';
import { CallReasonComponent } from './components/call-reason/call-reason.component';
import { CallRecordingComponent } from './components/call-recording/call-recording.component';
import { KeywordSlideshowComponent } from './modules/search/keyword-slideshow/keyword-slideshow.component';
import { NotificationComponent } from './components/common/notification/notification.component';
// import { ImageSliderComponent } from './components/image-slider/image-slider.component';



@NgModule({
  declarations: [
    AppComponent,
    // DndDirective,
    ConfirmEqualValidatorDirective,
    ManagePhotoComponent,
    // ImageSliderComponent,
    LoaderComponent,
    PopupComponent,
    CommonCounterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularMaterialModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NpnSliderModule,
    HttpClientModule,
    MDBBootstrapModule.forRoot(),
    NgMultiSelectDropDownModule,
    SlickCarouselModule,
    NgtUniversalModule,
    SharedModuleModule,
    CarouselModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    // MatDatepickerModule,
    CommonModule,
    ScrollingModule,
    // MatCardModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: WebReqInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    Data,
    CookieService,
    EmailService,
    MessagingService,
    AuthGuard, UtilitiesService
  ],
  exports: [SharedModuleModule,AngularMaterialModule],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [LoaderComponent, ImageSliderComponent,
    EditViewSlideShowComponent, BrokerCreateDialogComponent, ProfileTypeDialogComponent, CustomersDialogComponent,
    CustomerLeftUpdateDialogComponent, ReasonDialogComponent, OldSlideShowComponent, FormatHistoryComponent, CreateemployeeComponent,TicketHistoryComponent,
    CallReasonComponent,CallRecordingComponent,KeywordSlideshowComponent, NotificationComponent
     
  ]
})
export class AppModule { }
// platformBrowserDynamic().bootstrapModule(AppModule);
